//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
let d=[[[0,"BaseString",1,0],[0,"NamingRule",1,0],[0,"ReplaceString",1,0]],[[["n_source_expressions","source_expressions","destination_names"],"GetExpressions",{},0,0],[["source_expressions","destination_names"],"SetExpressions",{},2,0],[["target_part_occ","source_part_occ","source_expressions","destination_names"],"SetExpressionsFor4gd",{},4,0]],[]];
SPLM.InterpartExpressionsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.InterpartExpressionsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.InterpartExpressionsBuilder.NamingRules = Object.freeze({
    "AddPrefix" : "AddPrefix", "AddSuffix" : "AddSuffix", "Replace" : "Replace", "RenameWithIndex" : "RenameWithIndex"});

export default SPLM;